import en from "./languages/en";
import nl from "./languages/nl";

const messages = {
    en: en,
    nl: nl
};

export default messages;